<template>
	<div class="box">
		<div class="header" style="margin-bottom:5px">基本信息</div>
		<el-divider />
		<div>
			<div class="form">
				<select-year v-model="sclDate.year" style="width:90px" class="no-border" @change="saveRecordClass" />
				<select-term v-model="sclDate.term" style="width:90px" :term="sclDate.term" class="no-border"
					@change="saveRecordClass" />
				<select-week v-model="sclDate.week" :week="sclDate.week" class="no-border" style="width:70px"
					@change="saveRecordClass" />
			</div>
			<div>
				<span style="font-size:14px;margin-right:10px">实录班别:</span>
				<select-class :classId="classId" :range="true" :school_year="sclDate.year" class="no-border"
					ref="selectClassRef" @change="onClassChange" style="width:120px" />
			</div>
			<!-- 最好不让其修改，因为修改之后在我的实录中就会看不到了，这容易引起误解 -->
			<!-- <div>
				<span style="font-size:14px;margin-right:10px">实录人员:</span>
				<select-user ref="selectAuthorRef" :userId="authorId" class="no-border" style="width:90px"
					@change="onAuthorChange" />
			</div> -->
		</div>

		<div class="header" style="margin:10px 0">学生评价</div>
		<el-divider />
		<div v-for="(item,idx) in studentTags" :key="idx" class="item">
			<div class="student-name">{{item.student.name}}的评价:</div>
			<student-tag-cascader disabled :show-all-levels="false" :border="true" :selectedTags="item.tags"
				filterable />
		</div>
	</div>
</template>

<script>
	import { studentTapApi, recordApi, documentApi } from '@/boot-api/record'
	import SelectClass from '@/components/select-class.vue'
	import SelectTerm from '@/components/select-term.vue'
	import { mapState } from 'vuex'
	import Select from '@/components/products/select.vue'
	import SelectYear from '@/components/select-year.vue'
	import SelectWeek from '@/components/select-week.vue'
	import StudentTagCascader from '@/views/record/record-tag-cascader.vue';
	import SelectUser from '@/components/select-user.vue'

	export default {
		components: { SelectClass, SelectTerm, Select, SelectYear, SelectWeek, StudentTagCascader, SelectUser },

		data() {
			const schoolDate = this.$store.state.school.schoolDate;
			const recordInfo = this.$store.state.record.recordInfo;
			return {
				visible: false,
				tagResult: [],
				classId: recordInfo.classId || -1,
				sclDate: {
					year: recordInfo.schoolYear || schoolDate.year,
					term: recordInfo.schoolTerm || schoolDate.term,
					week: recordInfo.schoolWeek || schoolDate.week
				},
				docId: recordInfo.docId,
				authorId: recordInfo.authorId

			}
		},
		computed: {
			...mapState('record', {
				studentTags(state) {
					return state.studentTags.filter(v => v.studentId != 0)
				}
			})
		},

		methods: {
			open(name, docId) {
				this.name = name
				this.docId = docId
				this.visible = true
			},
			async saveRecordClass() {
				if (this.classId > 0) {
					await recordApi.save({
						docId: this.docId,
						schoolWeek: this.sclDate.week,
						schoolYear: this.sclDate.year,
						schoolTerm: this.sclDate.term,
						classId: this.classId
					})
					await this.$store.dispatch('record/getRecordInfo', this.docId)
				}
			},
			onSelectStudentId(studentId) {
				if (!studentId) return
				if (this.studentTags.some(v => v.studentId == studentId)) {
					this.$message.warning('已经存在该学生了')
					this.$refs.addStudentRef.reset()
					return
				}
				this.studentTags.push({
					studentId,
					tagIds: []
				})
				this.$refs.addStudentRef.reset()
			},
			async onClassChange(id) {
				// 非初始化状态情况下才需要进行这部分逻辑
				if (!(this.classId == -1 || this.classId == id) && this.studentTags.length > 0) {
					const tmpClassId = this.classId
					this.classId = ''
					this.$confirm('切换班级将清空现在的评价内容! 确定切换吗？', '提示').then(async (res) => {
						const studentIds = this.studentTags.map(v => v.studentId)
						await studentTapApi.remove({ docId: this.docId, studentIds })
						this.$message.success('成功清空')
						this.classId = id
						this.$refs.selectClassRef.blur()
						await this.saveRecordClass()
						this.$store.dispatch('record/getRecordInfo', this.docId)
						this.$store.dispatch('record/getStudentTags', this.docId)

					}).catch(() => {
						this.classId = tmpClassId
						this.$refs.selectClassRef.blur()
					})
				} else {
					this.classId = id
					await this.saveRecordClass()
					this.$store.dispatch('record/getRecordInfo', this.docId)
				}
			},


			selectFromTags(item) {
				const nodes = this.$refs.allStudentTagRef.getCheckedNodes(true)
				let allTags = []
				nodes.forEach(v => {
					let label = v.label
					function parse(node) {
						label = node.label + '/' + label
						if (node.parent) {
							parse(node.parent)
						}
					}
					parse(v.parent, label)
					allTags.push({
						label,
						id: v.value
					})
				})
				this.$refs.selectNoStudentTagRef.open(this.docId, item, allTags)
			},

			async onAuthorChange(authorId) {
				this.$confirm('确定修改实录人员？', '提示').then(async res => {
					this.authorId = authorId
					await documentApi.save({ authorId, id: this.docId })
					this.$message.success('修改实录人员成功')
					this.$refs.selectAuthorRef.blur()
				}).catch(() => {
					this.$refs.selectAuthorRef.blur()
				})
			}

		},
		mounted() {

			this.$store.dispatch('record/getStudentTags', this.docId)

		}
	}
</script>

<style lang="scss" scoped>
	.student-name {
		font-weight: bold;
		font-size: 14px;
		margin-bottom: 5px;
	}
	.noStudentTag {
		font-weight: bold;
		color: #606266;
		padding-bottom: 10px;
	}

	.no-border {
		& /deep/ .el-input__inner {
			border: none;
			padding: 0;
		}
		// & /deep/ .el-input__suffix {
		// 	.el-icon-arrow-up {
		// 		display: none;
		// 	}
		// }
	}
	.item {
		margin-bottom: 15px;
	}
	.form {
		display: flex;
		justify-content: space-between;
		font-size: 14px;
		// margin-bottom: 10px;
	}
	.box {
		width: 300px;
		height: calc(100% - 40px);
		border: 1px solid #e4e7ed;
		background: white;
		position: absolute;
		overflow: auto;

		top: 20px;
		left: calc(50% - 400px - 300px - 10px);
		padding: 15px 12px;
		.header {
			font-size: 18px;
			font-weight: bold;
			width: 100%;
			display: flex;
			justify-content: space-between;
			align-items: center;
			color: #303133;
			// padding: 10px;
		}
		& /deep/ .el-divider--horizontal {
			margin: 0 0 15px 0;
		}
	}
</style>


// WEBPACK FOOTER //
// src/views/record/student-tag/record-student-tag.vue